import React, { useContext } from "react";
import { Topic } from "../../components/item-content-two/Topic";
import { MultiSelectOption } from "../../models/MultiSelectOption";

export interface TopicContextType {
    data: MultiSelectOption[],
    itemId: string
    onSearch: (searchTerm: string) => void;
    topic: Topic;
    selectedItem?: MultiSelectOption
}

const defaultTopicContextValue: TopicContextType = {
    data: [],
    itemId: '',
    onSearch: () => {},
    topic : {
        accessor: '',
        allItemsPath: '',
        itemPath: '',
        title: '',
    }
}

export const TopicContext = React.createContext<TopicContextType>(defaultTopicContextValue);

export const  useTopicContext = () => {
    return useContext(TopicContext)
}
